import { PageProps } from "gatsby";
import { i18nInstance } from "@preem/core";
import { GlobalContextProvider } from "@preem/core";
import { registerLinkComponent } from "@preem/core/ssr";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { LazyMotion } from "motion/react";
import "dayjs/locale/sv";
import dayjs from "dayjs";
import { useEffect } from "react";
import { GatsbyLink } from "../elements/gatsby-link";

type TWrapPageElementProps = {
  children: React.ReactNode;
  props: PageProps<Record<string, unknown>, unknown>;
};

registerLinkComponent(GatsbyLink);

export const WrapPageElement = ({ children }: TWrapPageElementProps) => {
  return (
    <div className="preem-ds-structure preem-ds-typography preem-ds-theming">
      <div className={`preem-se`}>
        <div className={`preem-ds-context`}>
          <div className={`preem-ds-components`}>
            {children}
            <div id="portalContainer" />
          </div>
        </div>
      </div>
    </div>
  );
};

type TWrapRootElementProps = {
  children: React.ReactNode;
};

const loadFeatures = () => import("../async-files/framer-async").then((res) => res.default);

export const WrapRootElement = ({ children }: TWrapRootElementProps) => {
  const queryClient = new QueryClient();

  useEffect(() => {
    dayjs.locale("sv");
  }, []);

  return (
    <GlobalContextProvider>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18nInstance}>
          <LazyMotion features={loadFeatures}>{children}</LazyMotion>
        </I18nextProvider>
      </QueryClientProvider>
    </GlobalContextProvider>
  );
};
